const REGISTER_USER = '/RegisterUser';
const RESENDCODE = '/ResendCode';
const RESETPASSWORD = '/ResetPassword';
const AUTHENTICATE = '/authenticate';
const LOGIN_AS_ADMIN = '/LoginAsAdmin';
const LOGIN_LIST = '/UserInfo/LoginAs';
const TEMPLATES = '/templates';
const TEMPLATE_TO_EXCEL = '/ECoCExcelUploader';
const JOBS = '/jobs';
const JOBS_EXCEL = '/JobsSearch/ExportJobsSearchToExcel';
const SUPPLIES_EXCEL = '/OrdersSearch/ExportToExcel';
const TEMPLATES_EXCEL = '/TemplatesSearch/ExportToExcel';
const SUBMISSIONS = '/submissions';
const JOBTOTEMPLATE = '/templates/importjob';
const SUPPLIES = '/orders';
const USERINFO = '/userinfo';
const CLIENTS = '/clients';
const CUSTOMIZETABLE = '/customizetable';
const INVOICES = '/invoices';
const SAMPLES = '/samples';
const SELECTED_INVOICES = '/SelectedInvoices';
const EXCEL_TO_SUBMISSION = '/ECoCExcelUploader';
const FILTERFIELDS = '/projectfilters';
const FILTERITEMS = '/projects';
const PINFILTERITEM = '/pinprojects';
const ACCOUNTS = '/accounts';
const RESOURCES = '/resources';
const CRITERIA = '/criteriaandexceedences';
const TERMS = '/termsandconditions';
const SUBMISSIONTYPES = '/submissiontype';
const SITEPROVINCE = '/SiteProvince';
const MATRICES = '/matrices';
const SHIPPING_METHODS = '/shippingmethods';
const MAXXAM_DESTINATIONS = '/maxxamdestinations';
const ORDER_SUPPLIES = '/ordersupplies';
const VALIDATE_TASK_ORDER = '/taskorder/validate';
const DOWNLOAD_JOB_FILE = '/jobs/files/downloadpdf';
const REPORTS = '/customreports/reports';
const REPORT_CLIENTS = '/customreports/clients';
const REPORT_FORMATS = '/customreports/formats';
const REPORT_JOBS = '/customreports/jobs';
const REPORT_SAMPLES = '/customreports/samples';
const REPORT_PARAMETERS = '/customreports/parameters';
const REPORT_CRITERIA = '/customreports/criteria';
const REPORT_GENERATE = '/customreports/generatereport';
const REPORT_DELETE = '/customreports/deletereport';
const REPORT_DOWNLOADFILE = '/customreports/downloadfile';
const REPORT_COPY = '/customreports/copyreport';
const REPORT_EDIT = '/customreports/modifyreport';
const USER_MANAGE = '/usermanage';
const USER_ACCESS = '/accessright';
const USER_ACCESS_ATTENTIONS = '/accessright/accessrightreport';
const WATERWORK = '/waterwork';
const ORDER_WATER_WORK = '/waterwork/orderwaterwork';
const NOTIFICATIONS = '/notification';
const SERVICELEVELSLIST = '/templates/servicelevelslist';
const STORAGECONDITIONS = '/templates/shelflife';
const SIGN_OUT = '/signout';
const TASK_ORDER = '/taskorder/validate';
const RECOMMEND_TESTS = '/Elastic/Recommend';
const ORDER_PROVINCES = '/Orders/Provinces';
const ORDER_COUNTRY = '/Orders/Country';
const ETRID_MANAGEMENT = '/ETRIDManagement';
const QC_TYPE_OPTIONS = '/Orders/QCTypeOptions';
const CONFIGURATION = '/Configuration';
const ADDITIONAL_ANALYSIS = '/AdditionalAnalysis';
const SPLIT_REPORTS = '/SplitReports';
const SPLIT_REPORTS_SINGLE_PDF_REQUEST = '/SplitReports/SinglePdfRequest';
const SPLIT_REPORTS_REQUESTS = '/SplitReports/Requests';
const SPLIT_REPORTS_REQUEST_UPDATE = '/SplitReports/UpdateRequest';
const SPLIT_REPORTS_REQUEST_REPORTS = '/SplitReports/{REQUEST_ID}';
const SPLIT_REPORTS_DELETE = '/SplitReports/';
const GET_EDIT_JOB = '/GetEditJob';
const SPLIT_REPORTS_SAMPLE_REQUEST = '/SplitReports/{JOB_NUMBER}/Samples';
const SPLIT_REPORTS_ADD_REQUEST = '/SplitReports/AddRequest';
const SPLIT_REPORTS_UPDATE_REQUEST = '/SplitReports/UpdateRequest';
const PREPAID_REQUESTS = '/PrepaidSubmissions';

export {
  CONFIGURATION,
  AUTHENTICATE,
  LOGIN_AS_ADMIN,
  LOGIN_LIST,
  TEMPLATES,
  TEMPLATE_TO_EXCEL,
  JOBS,
  JOBS_EXCEL,
  SUBMISSIONS,
  JOBTOTEMPLATE,
  SUPPLIES,
  USERINFO,
  CLIENTS,
  CUSTOMIZETABLE,
  INVOICES,
  SELECTED_INVOICES,
  EXCEL_TO_SUBMISSION,
  FILTERFIELDS,
  FILTERITEMS,
  PINFILTERITEM,
  ACCOUNTS,
  RESOURCES,
  CRITERIA,
  TERMS,
  SAMPLES,
  SUBMISSIONTYPES,
  MATRICES,
  SHIPPING_METHODS,
  MAXXAM_DESTINATIONS,
  ORDER_SUPPLIES,
  VALIDATE_TASK_ORDER,
  DOWNLOAD_JOB_FILE,
  REPORTS,
  REPORT_CLIENTS,
  REPORT_FORMATS,
  REPORT_JOBS,
  REPORT_SAMPLES,
  REPORT_PARAMETERS,
  REPORT_CRITERIA,
  REPORT_DELETE,
  REPORT_COPY,
  REPORT_EDIT,
  REPORT_DOWNLOADFILE,
  REPORT_GENERATE,
  USER_MANAGE,
  USER_ACCESS,
  USER_ACCESS_ATTENTIONS,
  WATERWORK,
  ORDER_WATER_WORK,
  NOTIFICATIONS,
  SERVICELEVELSLIST,
  STORAGECONDITIONS,
  SIGN_OUT,
  SUPPLIES_EXCEL,
  TEMPLATES_EXCEL,
  TASK_ORDER,
  RECOMMEND_TESTS,
  ORDER_PROVINCES,
  QC_TYPE_OPTIONS,
  ORDER_COUNTRY,
  ETRID_MANAGEMENT,
  ADDITIONAL_ANALYSIS,
  RESENDCODE,
  RESETPASSWORD,
  REGISTER_USER,
  SPLIT_REPORTS_SAMPLE_REQUEST,
  SPLIT_REPORTS_ADD_REQUEST,
  SPLIT_REPORTS,
  SPLIT_REPORTS_REQUESTS,
  SPLIT_REPORTS_REQUEST_UPDATE,
  SPLIT_REPORTS_REQUEST_REPORTS,
  SPLIT_REPORTS_SINGLE_PDF_REQUEST,
  SPLIT_REPORTS_DELETE,
  SPLIT_REPORTS_UPDATE_REQUEST,
  GET_EDIT_JOB,
  PREPAID_REQUESTS,
  SITEPROVINCE,
};



// WEBPACK FOOTER //
// ./src/constants/apis.js